import {Decoration} from "@codemirror/view";

const decorationCodeBlock = Decoration.line({class: 'highlight-code-block'});
const decorationTable = Decoration.mark({class: 'highlight-table'});
const decorationQuote = Decoration.line({class: 'highlight-quote'});
const decorationHorizontalRule = Decoration.mark({class: 'highlight-horizontal-rule'});

export const decorators = [
  codeFragmentDecorator,
  blockQuoteDecorator,
  tableDecorator,
  ruleDecorator,
];

function blockQuoteDecorator(type, start, end, set, line) {
  if (type === 'Blockquote') {
    set.decorateLine(line.from, decorationQuote);
  }
}

function codeFragmentDecorator(type, start, end, set, line) {
  if (type === 'CodeBlock' || type === 'FencedCode') {
    set.decorateLine(line.from, decorationCodeBlock);
    return false;
  }
}

function tableDecorator(type, start, end, set, line) {
  if (type === 'Table') {
    set.decorate(line.from, end, decorationTable);
  }
}

function ruleDecorator(type, start, end, set, line) {
  if (type === 'HorizontalRule') {
    set.decorate(line.from, end, decorationHorizontalRule);
  }
}
